import axiosInstance from "app/axiosInstance";
import { customerPortal } from "@vilocnv/allsetra-core";

type ObjectForMapRequestDto = customerPortal.objects.ObjectForMapRequestDto;

export const getObjectDataForMap = async (payload: ObjectForMapRequestDto) => {
  try {
    const { accountId, objectId } = payload;
    const response = await axiosInstance.get(
      `/accounts/${accountId}/objects/${objectId}/map`
    );

    if (response.status === 200) {
      return response.data;
    }

    return [];
  } catch (e: any) {
    console.error(e);
    throw e;
  }
};
